import React from "react";
import { Select, DatePicker } from "antd";

export const CUSTOM = "custom";

export const DATE_FILTER_OPTIONS = [
  { label: "Today", value: "TODAY" },
  { label: "Yesterday", value: "YESTERDAY" },
  { label: "This Week", value: "THIS_WEEK" },
  { label: "Last Week", value: "LAST_WEEK" },
  { label: "Month to date", value: "THIS_MONTH" },
  { label: "Last Month", value: "LAST_MONTH" },
  { label: "Last 30 Days", value: "LAST_30_DAYS" },
  { label: "Custom Date", value: CUSTOM },
];

/**
 * Reusable Date Range Filter Component
 * Combines a date filter dropdown with optional custom date range picker
 *
 * @param {string} dateFilter - Current selected date filter value
 * @param {Array} dateRange - [startDate, endDate] dayjs objects for custom range
 * @param {Function} onDateFilterChange - Callback when date filter dropdown changes (value) => void
 * @param {Function} onDateRangeChange - Callback when custom date range changes ([startDate, endDate]) => void
 * @param {Array} options - Custom filter options (defaults to DATE_FILTER_OPTIONS)
 * @param {number} selectWidth - Width of the select dropdown (default: 150)
 * @param {string} className - Additional class names for the container
 */
const DateRangeFilter = ({
  dateFilter,
  dateRange,
  onDateFilterChange,
  onDateRangeChange,
  options = DATE_FILTER_OPTIONS,
  selectWidth = 150,
  className = "",
  label = "",
  placeholder = "Select date filter",
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {label && <span className="font-normal text-black-65 text-sm">{label}:</span>}
      <Select
        value={dateFilter || undefined}
        style={{ width: selectWidth }}
        onChange={onDateFilterChange}
        options={options}
        placeholder={placeholder}
        allowClear
      />
      {dateFilter === CUSTOM && (
        <DatePicker.RangePicker value={dateRange} onChange={onDateRangeChange} />
      )}
    </div>
  );
};

export default DateRangeFilter;
